import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './baseQuery';

export const InstitutionsApi = createApi({
  reducerPath: 'InstitutionApi',
  baseQuery: baseQueryWithReauth,
  refetchOnFocus: true,
  refetchOnReconnect: true,
  endpoints: (builder) => ({
    getInstitutions: builder.query({
      query: () => ({
        url: 'Institutions',
      }),
      providesTags: ['Institutions'],
    }),
    searchInstitutions: builder.query({
      query: ({ q = '', branch = '', source = 'all', limit = 20 } = {}) => ({
        url: `Institutions/lookup?q=${encodeURIComponent(q)}&branch=${encodeURIComponent(branch)}&source=${encodeURIComponent(source)}&limit=${limit}`,
      }),
      transformResponse: (response) => response?.items || [],
    }),
    addInstitution: builder.mutation({
      query: (Institution) => ({
        url: 'Institutions',
        method: 'POST',
        body: Institution,
      }),
      invalidatesTags: ['Institutions'],
      transformResponse: (response) => {
        return response;
      },
    }),
    modifyInstitution: builder.mutation({
      query: (Institution) => ({
        url: `Institutions/${Institution._id}`,
        method: 'PATCH',
        body: Institution,
      }),
      invalidatesTags: ['Institutions'],
      transformResponse: (response) => {
        return response;
      },
    }),
    deleteInstitution: builder.mutation({
      query: (Institution) => ({
        url: `Institutions/${Institution}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Institutions'],
      transformResponse: (response) => {
        return response;
      },
    }),
  }),
});

export const {
  useGetInstitutionsQuery,
  useLazySearchInstitutionsQuery,
  useAddInstitutionMutation,
  useModifyInstitutionMutation,
  useDeleteInstitutionMutation
} = InstitutionsApi;